module.exports = require('./lib/html-to-text');


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-to-text/index.js
// module id = f35r
// module chunks = 0